import { useEffect, useState } from "react";
import { hoursToMinutes } from "utils";
import { useIntervention } from "hooks/useIntervention";

export type ForfaitUsage = {
  consumed: number;
  lastIntervention: Date | null;
};

// Couleur du temps restant : rouge si épuisé ou dépassé, orange à 1h ou moins
export function warningColor(remainingHours: number) {
  const remainingMinutes = hoursToMinutes(remainingHours);
  if (remainingMinutes <= 0) {
    return "red";
  }
  if (remainingMinutes <= 60) {
    return "orange";
  }
  return "teal";
}

// Temps consommé sur un forfait et date de sa dernière intervention ; null pendant la première lecture,
// ou tant qu'il n'y a pas de forfait à lire
export function useForfaitUsage(idForfait: string | undefined, refresh?: number) {
  const [usage, setUsage] = useState<ForfaitUsage | null>(null);
  const { getInterventionsByIdForfait } = useIntervention();
  useEffect(() => {
    if (!idForfait) {
      return;
    }
    let isMounted = true; // Variable de suivi pour vérifier si le composant est monté
    const fetchData = async () => {
      const fetchedInterventions = await getInterventionsByIdForfait(idForfait);
      if (isMounted) {
        if (fetchedInterventions) {
          const consumed = fetchedInterventions.reduce(
            (acc, obj) => acc + obj.temps_passe,
            0
          );
          const tableData = fetchedInterventions.sort(
            (a: any, b: any) =>
              b.date_intervention.seconds - a.date_intervention.seconds
          );
          let lastData: any;
          if (tableData[0].date_intervention instanceof Date) {
            lastData = tableData[0].date_intervention;
          } else {
            lastData = new Date(
              Number(tableData[0].date_intervention.seconds) * 1000 +
                Number(tableData[0].date_intervention.nanoseconds) / 1000000
            );
          }
          setUsage({ consumed, lastIntervention: lastData });
        } else {
          setUsage({ consumed: 0, lastIntervention: null });
        }
      }
    };
    fetchData();
    return () => {
      isMounted = false; // Définir la variable isMounted sur false lors du démontage du composant
    };
  }, [idForfait, refresh, getInterventionsByIdForfait]);

  return usage;
}
